import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("rect", {
  width: "258",
  height: "203",
  rx: "10",
  fill: "#F3F6F8"
}, null, -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass($props.col)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.box)
    }, [
      (_openBlock(), _createElementBlock("svg", {
        width: "258",
        height: "203",
        class: _normalizeClass(_ctx.$style.substrate),
        viewBox: "0 0 258 203",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, _hoisted_2, 2)),
      _createElementVNode("img", {
        src: `${$props.url}`,
        alt: "",
        class: _normalizeClass(_ctx.$style.img)
      }, null, 10, _hoisted_3),
      ($props.callback)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($props.callback && $props.callback(...args))),
            class: _normalizeClass(_ctx.$style.action)
          }, [
            _createVNode(_component_Icon, { name: "trash" })
          ], 2))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}